module.exports = __webpack_public_path__ + "img/logo.d177d95f.png";